
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.2 5.778h-2.853L14.7 4H9.3L7.653 5.778H4.8c-.99 0-1.8.8-1.8 1.778v10.666C3 19.2 3.81 20 4.8 20h14.4c.99 0 1.8-.8 1.8-1.778V7.556c0-.978-.81-1.778-1.8-1.778zM12 17.333c-2.484 0-4.5-1.99-4.5-4.444H5.7l2.25-2.222 2.25 2.222H8.4c0 1.964 1.611 3.555 3.6 3.555.522 0 1.017-.115 1.458-.31l.666.657c-.639.329-1.35.542-2.124.542zm4.05-2.222L13.8 12.89h1.8c0-1.965-1.611-3.556-3.6-3.556-.522 0-1.017.116-1.458.311l-.666-.648c.639-.338 1.35-.552 2.124-.552 2.484 0 4.5 1.992 4.5 4.445h1.8l-2.25 2.222z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    